import {
  Input,
  Component,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { ModalRef } from './modal-ref';
import { ModalSize } from './modal.config';

@Component({
  selector: 'ps-ui-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalComponent implements AfterViewInit, OnInit {
  @Input() size?: ModalSize;
  @Input() showButtonClose: boolean = true;
  @ViewChild('modal') modal!: ElementRef;

  constructor(private _modalRef: ModalRef<ModalComponent>) {}

  ngOnInit(): void {
    if (this.size) {
      this._modalRef.resize(this.size);
    }
  }

  ngAfterViewInit() {
    this.focusModal();
  }

  /*
   * focusing modal is required to close with esc key.
   */
  focusModal() {
    this.modal.nativeElement.focus();
  }

  close() {
    this._modalRef.close();
  }
}
